import { render } from "./VendorUpdate.vue?vue&type=template&id=279b6f7b"
import script from "./VendorUpdate.vue?vue&type=script&lang=js"
export * from "./VendorUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__